import fetch from '../../utils/fetch';
import moment from 'moment';

export const NOTIFICATIONS_SENT = 'NOTIFICATIONS_SENT';

export const send = consignmentIds => (dispatch, getState) => {
  return fetch('api/consignment/notifications/', {
    method: 'POST',
    body: JSON.stringify({
      consignmentIds,
      reminderSent: moment(new Date()).format(),
    }),
  })(dispatch, getState).then(result => {
    dispatch({
      type: NOTIFICATIONS_SENT,
      consignmentIds,
    });
    return result;
  });
};
